import {merchantTransactionService} from '@/services/merchants/transactionService';
import type {AfriexAdminTransaction} from '@/types';
import {AfriexTransactionProcessor} from '@/types/ProcessorTypes';

/**
 * When a transaction's processor is AFRIEX_API (our business API), surface the
 * actual underlying processor used for the transaction alongside the internal
 * API label, by looking up the linked business transaction.
 * @param transaction The transaction to resolve the processor for.
 * @returns The transaction with `lastMileProcessor` set to the real processor
 * name when applicable, otherwise the original transaction unchanged.
 */
export const resolveTransactionProcessor = async (
  transaction: AfriexAdminTransaction,
): Promise<AfriexAdminTransaction> => {
  const isAfriexApi =
    transaction.processor?.toUpperCase() ===
    AfriexTransactionProcessor.AFRIEX_API;

  if (!isAfriexApi || !transaction.processorTransactionId) {
    return transaction;
  }

  try {
    const businessTransaction =
      await merchantTransactionService.getBusinessTransaction({
        id: transaction.processorTransactionId,
      });
    const processorName =
      businessTransaction?.meta?.processorMeta?.processorName;
    if (processorName) {
      return {...transaction, lastMileProcessor: processorName};
    }
  } catch (_err) {
    // Keep the original processor label if the lookup fails.
  }

  return transaction;
};
